var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBabybett = function SvgBabybett(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5H20.7156M21 0V18.7583M1 0L1 18.7583M1 14.5H20.7156M1 11.5H20.7156M3.5 4L3.5 11M6.5 4L6.5 11M9.5 4V11M12.5 4V11M15.5 4V11M18.5 4V11",
    stroke: "black"
  })));
};
export default SvgBabybett;